import { create } from 'zustand'
import { Theme, themes, applyTheme } from '@/themes'

interface ThemeState {
  theme: Theme
  availableThemes: Theme[]
  setTheme: (theme: Theme) => void
  toggleTheme: () => void
  initializeTheme: () => void
}

export const useThemeStore = create<ThemeState>((set, get) => ({
  theme: 'light',
  availableThemes: Object.keys(themes) as Theme[],

  setTheme: (theme: Theme) => {
    applyTheme(theme)
    localStorage.setItem('4q:theme', theme)
    set({ theme })
  },

  toggleTheme: () => {
    const { theme, availableThemes } = get()
    const currentIndex = availableThemes.indexOf(theme)
    const nextIndex = (currentIndex + 1) % availableThemes.length
    const nextTheme = availableThemes[nextIndex]
    get().setTheme(nextTheme)
  },

  initializeTheme: () => {
    const saved = localStorage.getItem('4q:theme') as Theme | null
    const theme = saved && Object.keys(themes).includes(saved) ? saved : 'light'
    get().setTheme(theme)
  },
}))
